import { twMerge } from 'tailwind-merge';

import { Menu } from '@repo/media/lucide';

import { Button } from '@repo/components/button';

import { EnvironmentIndicator } from '@repo/features/environment-indicator';
import { resolveRuntimeEnvironment } from '@repo/utils/runtime-environment';

import { useIsSmall } from '~/hooks/use-is-small.ts';

import { AccountButton } from './account-button.tsx';
import { LogoLink } from './logo-link.tsx';

export function Header({ openMenu, className }: { className?: string | undefined; openMenu: () => void }) {
  const isSmall = useIsSmall();
  const environment = resolveRuntimeEnvironment({
    isDev: import.meta.env.DEV,
    appEnvironment: import.meta.env.VITE_APP_ENVIRONMENT,
  });

  return (
    <header className={twMerge(
      'h-12 px-3',
      'flex justify-between lg:justify-end items-center gap-4',
      'bg-navigation-bg  border-b border-b-secondary-200',
      className,
    )}
    >
      {' '}
      {isSmall
        ? (
            <>
              <div className="flex min-w-0 items-center gap-3">
                <LogoLink />
                <EnvironmentIndicator
                  visible={environment.visible}
                  label={environment.label}
                />
              </div>
              <div className="flex items-center gap-4">
                <AccountButton />
                <Button
                  size="icon-md"
                  icon={{ component: <Menu size={30} strokeWidth={1.5} aria-label="Open navigation menu" /> }}
                  action={() => { openMenu(); }}
                />
              </div>
            </>
          )
        : (
            <div className="flex items-center gap-4">
              <EnvironmentIndicator
                visible={environment.visible}
                label={environment.label}
              />
              <AccountButton />
            </div>
          )}
    </header>
  );
}
